import script from "./VAppSidebarButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./VAppSidebarButton.vue?vue&type=script&setup=true&lang=ts"

import "./VAppSidebarButton.vue?vue&type=style&index=0&id=081bcdde&lang=scss"

const __exports__ = script;

export default __exports__